import Endpoint from './endpoint'
import { API_URL } from './index'

export default class Templates extends Endpoint {
  async all(onlyActive = false) {
    let url = new URL(`/api/templates`, API_URL)

    if (onlyActive) {
      url.searchParams.set('active', true)
    }

    return this.request(url)
  }

  async one(id) {
    let url = new URL(`/api/templates/${id}`, API_URL)

    return this.request(url)
  }

  async save(template) {
    let url = new URL(`/api/templates/${'_id' in template ? template._id : ''}`, API_URL)
    return this.request(url, {
      method: '_id' in template ? 'PUT' : 'POST',
      body: JSON.stringify(template)
    })
  }

  async delete(id) {
    let url = new URL(`/api/templates/${id}`, API_URL)

    return this.request(url, {
      method: 'DELETE'
    })
  }
}
